<template>
  <div class="product-info-file">
    <div class="no-data" v-if="fileList.length < 1">{{ $t('Common.com_no_data') }}</div>
    <ul class="file-list" v-else>
      <li class="file-item" v-for="(item, index) in fileList" :key="index">
        <div class="file-name">{{ item.name }}</div>
        <i class="icon icon-xiazai" @click="$downloadFile(item.url, item.name)"></i>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    productId: [Number, String],
    productCodeId: [Number, String],
  },
  watch: {
    productCodeId: {
      handler(val) {
        if (val) {
          this.getOssAttach();
        }
      },
    },
  },

  // productCodeId
  data() {
    return {
      bizType: 'dms.product.doc',
      fileList: [],
    };
  },
  methods: {
    getOssAttach() {
      this.$getFileList({
        bizId: this.productCodeId,
        bizType: this.bizType,
      }).then((list) => {
        this.fileList = list;
      });
    },
  },
  mounted() {
    this.getOssAttach();
  },
};
</script>

<style lang="scss" scoped>
.product-info-file {
  .file-list {
    margin-top: 24px;
    .file-item {
      padding: 2px 10px 2px 12px;
      line-height: 28px;
      font-size: 12px;
      overflow: hidden;
      background: #f9f9fd;
      margin-bottom: 8px;
      color: #0d9ae0;
      .file-name {
        float: left;
        max-width: 50%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .icon {
        float: right;
        &:hover {
          cursor: pointer;
        }
      }
    }
  }
  .no-data {
    text-align: center;
    margin-top: 50px;
    color: #6c757d;
  }
}
</style>
